module.exports = __webpack_public_path__ + "14four/static/media/camera_button.3d403dac.png";